import { jsx, jsxs } from "react/jsx-runtime";
import { useRef, useState, useMemo, useEffect } from "react";
import styled from "styled-components";
import { IconArrowTop, IconArrowBottom } from "@bynder/icons";
import { Row } from "./Row2.js";
import { Cell } from "./Cell.js";
import { Head } from "./Head.js";
import { HeadCell } from "./HeadCell.js";
import { Body } from "./Body.js";
import { StopPropagation } from "./StopPropagation.js";
import { RowExpansion } from "./RowExpansion.js";
import { LoadingIndicator } from "./LoadingIndicator.js";
import { TableContext } from "./context7.js";
function Table({
  columnWidths,
  isFixedLayout = false,
  children,
  ...props
}) {
  const tableRef = useRef(null);
  const [columnsCount, setColumnsCount] = useState(0);
  const contextValue = useMemo(() => {
    return {
      columnsCount
    };
  }, [columnsCount]);
  useEffect(() => {
    var _a, _b;
    let headerCellsCount = 0;
    const headerCells = (_a = tableRef.current) == null ? void 0 : _a.querySelectorAll("thead th");
    if (headerCells) {
      for (const cell of headerCells) {
        headerCellsCount += cell.colSpan;
      }
    }
    const bodyCellsCount = ((_b = tableRef.current) == null ? void 0 : _b.querySelectorAll("tbody tr:nth-child(3) td").length) || 0;
    setColumnsCount(Math.max(headerCellsCount, bodyCellsCount));
  }, []);
  return /* @__PURE__ */ jsx(TableContext.Provider, {
    value: contextValue,
    children: /* @__PURE__ */ jsxs(StyledTable, {
      $isFixedLayout: isFixedLayout,
      ref: tableRef,
      ...props,
      children: [columnWidths && columnWidths.length > 0 && /* @__PURE__ */ jsx("colgroup", {
        children: columnWidths.map((width, index) => /* @__PURE__ */ jsx("col", {
          style: {
            width
          }
        }, String(index) + String(width)))
      }), children]
    })
  });
}
const StyledTable = styled.table.withConfig({
  displayName: "StyledTable",
  componentId: "sc-1t5tsic-0"
})(["width:100%;border-collapse:collapse;table-layout:", " !important;word-wrap:initial !important;"], (props) => props.$isFixedLayout ? "fixed" : "auto");
Table.Head = Head;
Table.HeadCell = HeadCell;
Table.Body = Body;
Table.Row = Row;
Table.Cell = Cell;
Table.RowExpansion = RowExpansion;
Table.LoadingIndicator = LoadingIndicator;
Table.StopPropagation = StopPropagation;
Table.IconUp = IconArrowTop;
Table.IconDown = IconArrowBottom;
export {
  Table
};
//# sourceMappingURL=Table.js.map
